import { Modal, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table/interface';
import { useCallback, useEffect, useMemo } from 'react';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { AuditResponse, ITrackingHistoryState } from '../../model/TrackingHistoryModal';
import { useTrackingHistoryStore } from '../../stores/TrackingHistoryStore';
import { DD_MM_YYYY_H_MM, expandedRowClassName } from '../../utils/app-common';
import { convertDateFromMillis } from '../../utils/luxon';
import TableComponent from '../CommonComponent/TableComponent';
type IAuditComponent = {
    isOpen: boolean,
    closeModal: () => void,
    waybillNo?: string,
};
export const AuditComponent = ({ getAuditData }: { getAuditData: () => void }) => {
    const { promiseInProgress: auditByWayByListProgress } = usePromiseTracker({ area: 'audit-by-way-bill-list-area' });
    const auditList = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.auditList);

    const auditColumn: ColumnsType<AuditResponse> = useMemo(() => [
        Table.EXPAND_COLUMN,
        {
            title: 'Record',
            dataIndex: 'name',
            key: 'name',
            width: 120,
        },
        {
            title: 'fieldName',
            dataIndex: 'fieldName',
            key: 'fieldName',
            width: 120,
        },
        {
            title: 'old Value',
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: 120,
            render: (oldValue) => (oldValue && oldValue.toString()?.length === 13) ? convertDateFromMillis(oldValue) : oldValue
        },
        {
            title: 'new Value',
            dataIndex: 'newValue',
            key: 'newValue',
            width: 120,
            render: (newValue) => (newValue && newValue.toString()?.length === 13) ? convertDateFromMillis(newValue) : newValue
        },
        {
            title: 'updated By',
            dataIndex: 'updatedBy',
            key: 'updatedBy',
            width: 120,
        },
        {
            title: 'updated Date',
            dataIndex: 'updatedDate',
            key: 'updatedDate',
            width: 120,
            render: (updatedDate: number) => convertDateFromMillis(updatedDate, DD_MM_YYYY_H_MM)
        },
    ], [])

    return (

        <TableComponent
            expandable={{
                // expandedRowRender: (record) => (
                //     <>
                //         <TableComponent columns={auditColumn}
                //             data={record?.children}
                //             rowKey='id'
                //             indentSize={1}
                //             size="small"
                //             hideOnSinglePage
                //             isLoading={false}
                //             scroll={{ x: 0, y: 0 }}
                //             isRefresh={false} />
                //     </>
                // ),
                expandRowByClick: true,
                columnWidth: 4,
                columnTitle: '',
                indentSize: 5,
                defaultExpandAllRows: false,
                expandedRowClassName: expandedRowClassName
            }}
            scroll={{ x: 0, y: 0 }}
            columns={auditColumn}
            isLoading={auditByWayByListProgress}
            data={auditList}
            rowKey='id'
            onRefreshHandle={() => getAuditData()}
            isRefresh />
    )
}

const AuditModalComponent = ({ isOpen, closeModal, waybillNo }: IAuditComponent) => {

    const GetAuditByWayBillAction = useTrackingHistoryStore((state: ITrackingHistoryState) => state?.GetAuditByWayBillAction)

    const getAuditData = useCallback(() => {
        if (waybillNo) {
            trackPromise(GetAuditByWayBillAction(waybillNo), 'audit-by-way-bill-list-area');
        }
    }, [GetAuditByWayBillAction, waybillNo])

    useEffect(() => {
        getAuditData();
    }, [getAuditData])

    return (
        <Modal maskClosable={false} open={isOpen} forceRender
            onOk={closeModal}
            title={`Airway Bill - ${waybillNo}`}
            centered
            onCancel={closeModal}
            width={1300}
            cancelButtonProps={{
                style: { display: 'none' }
            }}>
            <AuditComponent getAuditData={getAuditData} />
        </Modal>
    )
}

export default AuditModalComponent